
import React from "react";

import { Button, Dialog, DialogContent, DialogContentText, TextField, DialogActions, DialogTitle } from '@material-ui/core'
import ExaminerPaperList from "../papers/ExaminerPaperList";
import { Exam } from "../../../interfaces/examiner/Exam";
import { Paper } from "../../../interfaces/shared/Paper";

interface Props {
    exam:Exam
    onAdd:(paper:Paper) => void
    onClose:() => void
}

interface State {
}

export default class AddPaperToExamDialog extends React.Component<Props, State> {

    constructor(props:Props) {

        super(props)
    }

    render() {

        return (
            <div>
            <Dialog maxWidth="md" fullWidth open={true} onClose={this.props.onClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add Paper to Exam</DialogTitle>
                <DialogContent>
                    <ExaminerPaperList onSelect={this.onSelectPaper} exclude={this.props.exam.papers} readOnly />
                </DialogContent>
                <DialogActions>
                <Button onClick={this.onClose} color="secondary">
                    Cancel
                </Button>
                </DialogActions>
            </Dialog>
            </div>
        );
    }

    onClose = () => {
        this.props.onClose()
    }

    onSelectPaper = (paper:Paper) => {
        this.props.onAdd(paper)
    }
    
}

